import React from 'react';
import { CTAButton } from '../CTAButton';
import { UrgencyBlock } from '../UrgencyBlock';
const stack = [{
  label: '📘 Collezione Protocollo Clinico Sicuro™ (6 Tomi Premium)',
  value: '97 €'
}, {
  label: '🎁 5 Bonus Esclusivi',
  value: '197 €'
}];
const perks = ['Pagamento unico', 'Accesso a vita', 'Nessuna mensilità', 'Download immediato'];
export function Offer() {
  return <section id="offerta" className="bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-165" data-mp="3a5yte3l4m96i">
      <div className="mx-auto w-full max-w-2xl" data-id="element-166" data-mp="3f4ju044aiuvh">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.2em] text-gold-dark" data-id="element-167" data-mp="3f38pg230tj3b">
          🏆 Offerta speciale di lancio
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] font-bold leading-[1.15] text-ink sm:text-4xl" data-id="element-168" data-mp="3nwu29fvmkqa3">
          Questo è tutto ciò che riceverai oggi
        </h2>

        <div className="mt-7 overflow-hidden rounded-3xl border border-ink/10 bg-white shadow-[0_30px_60px_-45px_rgba(14,17,22,0.8)]" data-id="element-169" data-mp="3sttzd1ahyip2">
          <div className="p-6 sm:p-8" data-id="element-170" data-mp="1kl85ok7eit4z">
            <ul className="divide-y divide-ink/10" data-id="element-171" data-mp="1kn1h0csym1jb">
              {stack.map(item => <li key={item.label} className="flex items-start justify-between gap-4 py-3.5" data-id="element-172" data-mp="1fllvkjmvdt0e">
                  <span className="text-[14.5px] leading-snug text-ink/80" data-id="element-173" data-mp="16lp284pjc5z0">
                    {item.label}
                  </span>
                  <span className="shrink-0 text-[14px] font-bold text-ink/45 line-through" data-id="element-174" data-mp="23c7unlewc2y9">
                    {item.value}
                  </span>
                </li>)}
            </ul>
            <div className="mt-2 flex items-center justify-between gap-4 border-t-2 border-ink/15 pt-4" data-id="element-175" data-mp="1uimcrt7fq5km">
              <span className="text-[13px] font-extrabold uppercase tracking-[0.12em] text-ink" data-id="element-176" data-mp="1pjrvwwt12r35">
                Valore totale
              </span>
              <span className="font-display text-xl font-bold text-ink/50 line-through" data-id="element-177" data-mp="2n1rva8kty4v7">
                294 €
              </span>
            </div>
          </div>

          <div className="bg-ink px-6 py-8 text-center sm:px-8" data-id="element-178" data-mp="3160nlpqtqc9n">
            <p className="text-[12px] font-semibold uppercase tracking-[0.14em] text-cream/55" data-id="element-179" data-mp="364tqko8hikvk">
              Oggi puoi ottenere l’accesso completo per soli…
            </p>
            <p className="mt-2 font-display text-[56px] font-bold leading-none text-gold sm:text-7xl" data-id="element-180" data-mp="2weqzwuou5j0e">
              19 €
            </p>

            <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-3 gap-y-2" data-id="element-181" data-mp="2idy1vzzbs5sj">
              {perks.map(perk => <li key={perk} className="rounded-full border border-gold/25 px-3 py-1 text-[11.5px] font-semibold text-cream/75" data-id="element-182" data-mp="2nbzlqn4ks952">
                  {perk}
                </li>)}
            </ul>

            <p className="mx-auto mt-5 max-w-md text-[14px] leading-relaxed text-cream/65" data-id="element-183" data-mp="7nzns6drzv8d">
              Per meno di quanto costa una cena fuori, avrai una biblioteca
              professionale da consultare ogni volta che affronti un caso
              complesso.
            </p>

            <div className="mt-6" data-id="element-184" data-mp="1s5rz0538ximb">
              <CTAButton label="Voglio il Protocollo Clinico Sicuro" note="Pagamento unico di 19 € · Download immediato · Garanzia di 7 giorni" data-id="element-185" data-mp="1s6jwxmkbfsfr" />
            </div>

            <div className="mt-6" data-id="element-186" data-mp="214c94huqqjyx">
              <UrgencyBlock data-id="element-187" data-mp="2fub98q5uw5h1" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}